import { FrameType, type TourStep } from '@carboncopyco/types';
import { getTargetElementFromArea } from './getTargetElementFromArea';
import { getTargetElementFromNestedXpath } from './xpath';

export const getTargetElement = ({
  xpath,
  elementPosition,
  frameType,
  doc = document,
}: {
  xpath?: TourStep['xpath'];
  elementPosition?: TourStep['elementPosition'];
  frameType: FrameType;
  doc?: Document;
}) => {
  if (!xpath && !elementPosition) {
    return {
      documentRoot: doc,
      targetElement: doc.body,
    };
  }

  const { targetElement, documentRoot } =
    frameType === FrameType.recording
      ? getTargetElementFromNestedXpath(xpath, doc)
      : getTargetElementFromArea({
          documentRoot: doc,
          elementPosition,
        });

  return { targetElement, documentRoot };
};
